import React from "react";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";
import Hero from "../about/Hero";
import MissionSection from "../about/MissionSection";
const About = () => {
    return(  
         <>
          <MyNavbar/>
          <Hero/>
          <MissionSection/>
          <Footer/>
        
         </>
  );
};

export default About;